/**
 * Núcleo PURO e genérico de "algum OUTRO `tool_call` já resolveu este
 * `preview_id`, pela MESMA chave de cartão?" — extraído de
 * `cartao-campos-reuniao-desfecho-externo.js` [G-4, rodada-v5, 09/09/2026]
 * quando `fee-fixo/envio-relatorio` precisou do MESMO mecanismo (achado da
 * team-lead, QA da rodada-v5): o cartão de PREVIEW de uma escrita two-step
 * nunca recebe o desfecho na PRÓPRIA parte — o servidor mina um
 * `tool_call_id` novo para ele (`servidor-confirmacao-<uuid>`/
 * `protocolo-<uuid>`, ver o cabeçalho de `cartao-campos-reuniao-desfecho-
 * externo.js` para o histórico completo do achado) — e mais de um cartão do
 * módulo precisa da mesma correlação por `preview_id`.
 *
 * Cada cartão mantém o PRÓPRIO arquivo `*-desfecho-externo.js`, fixando a
 * `chave` (`ui.component`) e o VOCABULÁRIO de retorno — `campos-reuniao`
 * devolve `'confirmed'|'cancelled'`; `envio-relatorio` devolve
 * `'enviado'|'erro'|'cancelado'`, o vocabulário PRÓPRIO do cartão. Só a
 * VARREDURA das mensagens (as três superfícies de chat conhecidas + a busca
 * pelo `tool_calls[]` resolvido) é comum — extrair o VOCABULÁRIO junto
 * obrigaria os dois cartões a concordar numa terceira linguagem que nenhum
 * dos dois fala.
 *
 * Sem `?.`/`??` (o Babel deste projeto não transpila). Acentos UTF-8 reais.
 */

const ESTADO_COMMIT = 'output-available'

function lerCaminho(objeto, caminho) {
  return caminho.split('.').reduce((atual, chave) => {
    if (!atual || typeof atual !== 'object') return undefined
    return atual[chave]
  }, objeto)
}

// Os caminhos das TRÊS superfícies conhecidas — ver o cabeçalho de
// `cartao-campos-reuniao-desfecho-externo.js` para o histórico da descoberta
// (QA it.7, 09/09/2026): `aiFramework` guarda as mensagens num slice `chat`
// ANINHADO, ao contrário das outras duas.
const CAMINHOS_DE_MENSAGENS = [
  'aawz-intelligence-v2.messages',
  'feeFixoIa.messages',
  'aiFramework.chat.messages',
]

/** Concatena as mensagens das três superfícies de chat conhecidas do store. */
export function mensagensDaSuperficie(storeState) {
  const raiz = storeState || {}
  return CAMINHOS_DE_MENSAGENS.reduce((acumulado, caminho) => {
    const mensagens = lerCaminho(raiz, caminho)
    return Array.isArray(mensagens) ? acumulado.concat(mensagens) : acumulado
  }, [])
}

function partesResolvidas(mensagem) {
  return (mensagem && mensagem.tool_calls) || []
}

function parteResolveOPreview(parte, previewId, chave) {
  const ui = parte && parte.ui
  if (!ui || ui.component !== chave) return false
  if (parte.state !== ESTADO_COMMIT) return false
  const props = ui.props || {}
  return props.preview_id === previewId
}

function parteDoPreview(mensagens, previewId, chave) {
  for (const mensagem of mensagens || []) {
    const parte = partesResolvidas(mensagem).find((candidata) =>
      parteResolveOPreview(candidata, previewId, chave)
    )
    if (parte) return parte
  }
  return null
}

/**
 * Os `ui.props` da OUTRA mensagem que já resolveu (`output-available`) este
 * `previewId`, na chave `chave` — ou `null` sem match. Fail-closed: sem
 * `previewId` ou sem `chave`, nenhuma correlação é possível — nunca cai para
 * um fallback mais amplo (era o bug do `id_cliente_app`, ver o cabeçalho de
 * `cartao-campos-reuniao-desfecho-externo.js`).
 */
export function propsDoDesfechoExterno(mensagens, previewId, chave) {
  if (!previewId || !chave) return null
  const parte = parteDoPreview(mensagens, previewId, chave)
  if (!parte) return null
  return (parte.ui && parte.ui.props) || {}
}
